module.exports = __webpack_public_path__ + "static/Traditional-Hommus-603583498f98a5b36688f42eb7ee6f77.png";